import BaseLink, { LinkProps as BaseLinkProps } from 'next/link'
import React, { ComponentProps, PropsWithChildren } from 'react'

export type LinkProps = Omit<BaseLinkProps, 'legacyBehavior'> & Pick<ComponentProps<'a'>, 'target' | 'onClick'>

export const Link: React.FC<PropsWithChildren<PropsWithChildren<LinkProps>>> = ({ href, children, target, ...linkProps }) => {
  return href && href !== '#' && !target ? (
    <BaseLink legacyBehavior={true} href={href} { ...linkProps }>
      {children}
    </BaseLink>
  ) : (
    <a href={typeof href === 'string' ? href : (href?.href as string ?? '#')} target={target} onClick={linkProps.onClick}>
      {children}
    </a>
  )
}